export default {"src":"/_next/static/media/ic-search.79abf415.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};